import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { RegistrationService } from '../../services/registration.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Coursedata } from '../../data/coursedata.model';

@Component({
	selector: 'app-course-information',
	templateUrl: './course-information.component.html',
	styleUrls: ['./course-information.component.scss'],
	providers: [ConfirmationService]
})
export class CourseInformationComponent implements OnInit {
	msgs: Message[] = [];
	msgsResponse: Message[] = [];
	responsemsg: Message[] = [];
	activeIndex = 2;
	name: string;
	selectedData: any;
	dataList: any = [];
	tableData: Coursedata[];
	totalAmount: any;
	amount: any;
	coursedata: Coursedata = new Coursedata();
	selectedCourse: Coursedata;
	courseDetailInfo: any[];
	checked = false;
	data: any = [];
	displayConfirmDialog: boolean = false;
	selectedDataToShow = [];
	displayCourseNonEligible = false;
	nonEligiblemsg:any;
  showclose= false;
  showIneligiblebtn = false;
  displayIneligibleDialog: boolean = false;
  ineligiblecourseToShow = [];
  cols: any[];
  colsnew: any[];
  payField : boolean = true;

	constructor(
		private registrationService: RegistrationService,
		private confirmationService: ConfirmationService,
		private router: Router,
		private spinner: NgxSpinnerService
	) { }
	private token = JSON.parse(localStorage.getItem('userDetails'));
	ngOnInit() {
		this.spinner.show();
		// this.msgs = [];
		// this.msgs.push({ severity: 'info', summary: 'Please Note :' });
		// this.msgs.push({
		// 	severity: 'detail',
		// 	summary:
		// 		'i. Course / Session selected here can not be Removed once Saved.'
		// });
		// this.msgs.push({
		// 	severity: 'detail',
		// 	summary: 'ii. Multiple courses / Session can be added later on using the same login details.'
		// });
		// this.msgs.push({
		// 	severity: 'detail',
		// 	summary:
		// 		'iii. Application will be considered only after payment of Application Fees is made.'
		// });
		this.msgsResponse = [];
		this.responsemsg = [];
		this.autoLogin();
		this.getEligibleCourseList();
		this.courseDetailInfo = [];
		this.cols = [
			{ field: 'srl', header: 'Srl.' },
			{ field: 'coursenm', header: 'Course / Session Opted For' },
			// { field: 'amount', header: 'Total Application Fees to Pay	(Rs.)' }
    ];
    this.colsnew = [
      //{ field: 'srl', header: 'Srl.' },
			{ field: 'coursenm', header: 'Course' },
			{ field: 'msg', header: 'Reason' }
    ]
		if(localStorage.getItem('step')==''){
			this.showclose = true;
		}
	}
	getEligibleCourseList() {
		this.registrationService
			.getEligibleCourseListApi(this.token.authToken)
			.subscribe(data => {
				//console.log(data);
				this.dataList = data;
				this.tableData = this.dataList.CoursesList;
				this.amount = this.dataList.amount;
        this.spinner.hide();
        if(this.dataList.NECoursesList.length!=0){
          this.showIneligiblebtn = true;
          this.ineligiblecourseToShow = this.dataList.NECoursesList;
        }
				if (this.dataList.CoursesList.length === 0) {
					this.displayCourseNonEligible = true;
					this.nonEligiblemsg = this.dataList.msgcr;
				}
			},error=>{
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
	}
	acceptcourse(){
		this.displayCourseNonEligible = false;
		this.router.navigate(['admission/academic-information']);
	}
	rejectcourse(){
		this.displayCourseNonEligible = false;
		this.router.navigate(['']);
	}

	calculateAmount() {
		const courses = [...this.tableData];
		this.selectedData = {
			courseDetailsInfo: courses
		};
		let n = 0;
		for (let i = 0; i < this.selectedData.courseDetailsInfo.length; i++) {
			if (this.selectedData.courseDetailsInfo[i].selchxbx) {
				n++;
			}
		}
		this.totalAmount = this.amount * n;
	}

	autoLogin() {
		this.registrationService
			.loginByToken(localStorage.getItem('authToken'))
			.subscribe(
				data => {
					//console.log(data);
					this.dataList = data;
					localStorage.setItem('authToken', this.dataList.authToken);
					localStorage.setItem(
						'userDetails',
						JSON.stringify(this.dataList.userDetails)
					);
					localStorage.setItem('step', this.dataList.step);
				},
				err => console.log(err),
				() => console.log('Request Completed')
			);
	}

	saveCourseSelection = function () {
		var courses = this.tableData.slice();
		this.selectedData = {
			courseDetailsInfo: courses
		};
		var n = 0;
		for (var i = 0; i < this.selectedData.courseDetailsInfo.length; i++) {
			if (this.selectedData.courseDetailsInfo[i].selchxbx) {
				this.selectedDataToShow.push(this.selectedData.courseDetailsInfo[i]);
				n++;
			}
		}
		//console.log(this.selectedDataToShow);
		if (n === 0) {
			alert('Please select atleast one Course.');
			return false;
		}
		else {
			this.displayConfirmDialog = true;
			this.updateRowGroupMetaData();
		}
	};
	updateRowGroupMetaData = function () {
		this.rowGroupMetadata = {};
		if (this.selectedDataToShow) {
			for (var i = 0; i < this.selectedDataToShow.length; i++) {
				var rowData = this.selectedDataToShow[i];
				var selchxbx = rowData.selchxbx;
				if (i == 0) {
					this.rowGroupMetadata[selchxbx] = { index: 0, size: 1 };
				}
				else {
					var previousRowData = this.selectedDataToShow[i - 1];
					var previousRowGroup = previousRowData.selchxbx;
					if (selchxbx === previousRowGroup)
						this.rowGroupMetadata[selchxbx].size++;
					else
						this.rowGroupMetadata[selchxbx] = { index: i, size: 1 };
				}
			}
		}
	};

	accept = function () {
    this.spinner.show();
    this.displayConfirmDialog = false;
		this.registrationService
			.saveCourseSelectionApi(this.token.authToken, this.selectedData).subscribe(data => {
        // console.log(data);
        this.spinner.hide();
				this.dataList = data;
				if (this.dataList.status === 'success') {
					const dltid = data.dltid;
					const mask = data.mask;
					const mobno = data.mobno;
					const pw = data.pw;
					const un = data.un;
					const sub = data.sub;
					this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
					   console.log('SMS sent successfully:', response);
					})
					  .catch(error => {
						alert(error.message);
					  });
					this.displayConfirmDialog = false;
					this.msgsResponse.push({
						severity: 'success',
						summary: 'Success Message',
						detail: this.dataList.msg
					});
				}
				alert('Course details saved.');
				if (localStorage.getItem('step') !== '') {
					this.router.navigate(['admission/additional-information']);
				}
				else{
					this.router.navigate(['candidate/dashboard']);
				}
			},error=>{
        alert('Something went wrong. Please try again')
        this.spinner.hide();
      });
		//this.spinner.hide();
	};
	reject = function () {
		this.displayConfirmDialog = false;
		this.selectedDataToShow = [];
	};

	goToDashboard(){
		this.router.navigate(['candidate/dashboard']);
  }

  showineligibleCourse(){
    this.displayIneligibleDialog = true;
  }

  closemodal(){
    this.displayIneligibleDialog = false;
  }
  onFloatClick(){
    window.open("https://app.botbaba.io/bot/1158ALGR6Xj/BESC%20QBOT");
  }

  openEligibilityCriteria(){
    window.open("https://www.thebges.edu.in/wp-content/uploads/2020/07/CU-Criteria-2020-2021.pdf");
  }

}



// WEBPACK FOOTER //
// ./src/app/admission/course-information/course-information.component.ts